/* tslint:disable */
/* eslint-disable */
export enum WorkBudgetIstSourceEnum {
  CalculatedProjects = 'calculated_projects',
  CalculatedRevenue = 'calculated_revenue',
  Manual = 'manual',
  CalculatedInterDivisionErtrag = 'calculated_inter_division_ertrag',
  CalculatedInterDivisionAufwand = 'calculated_inter_division_aufwand'
}
